import { ChevronDown } from "lucide-react";

const questions = [
  {
    question: "Is this a medical tool?",
    answer: "No. It is an artistic and educational interface for reflection. It does not assess, diagnose, treat, or measure mental health."
  },
  {
    question: "Why make a museum of fears?",
    answer: "A museum creates distance. It lets a fear be observed as a pattern rather than treated as a private flaw."
  },
  {
    question: "Are these phobias?",
    answer: "Some names overlap with familiar fears, but the site presents broad human experiences, not clinical categories."
  },
  {
    question: "Does the site store my answers?",
    answer: "No. The site does not send reflections anywhere. Interactive values stay in the current browser state."
  },
  {
    question: "Can this help with anxiety?",
    answer: "It may support gentle reflection, but it is not a substitute for personal support or professional care."
  },
  {
    question: "Why does fear feel physical?",
    answer: "Fear prepares the body to respond to possible danger. That preparation can be felt as tension, heat, pressure, restlessness, or stillness."
  }
];

function FAQ() {
  return (
    <section className="mx-auto w-full max-w-5xl px-5 py-20 lg:px-8">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">Questions</p>
        <h2 className="mt-4 font-display text-4xl text-museum-bone sm:text-5xl">FAQ</h2>
      </div>
      <div className="space-y-3">
        {questions.map((item) => (
          <details key={item.question} className="group rounded-lg border border-museum-bone/12 bg-museum-panel/50 p-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-display text-xl text-museum-bone">
              {item.question}
              <ChevronDown className="shrink-0 text-museum-gold transition group-open:rotate-180" size={18} aria-hidden="true" />
            </summary>
            <p className="mt-4 leading-7 text-museum-muted">{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
